import { useEffect } from "react";
import { DOSHA_QUIZ_FAVICON_URL } from "./miniQuizConfig";

/**
 * Keeps the Maharishi favicon in sync across all icon link tags.
 * Set restoreOnUnmount=false when navigating to another dosha-quiz route
 * to avoid flashing back to /favicon.ico between mini quiz → mini result.
 */
export function useDoshaQuizFavicon({ restoreOnUnmount = true } = {}) {
  useEffect(() => {
    const defaultFaviconUrl = "/favicon.ico";
    const existingLinks = Array.from(document.querySelectorAll("link[rel*='icon']"));
    const originalHrefs = existingLinks.map((link) => ({
      element: link,
      href: link.href,
    }));

    existingLinks.forEach((link) => {
      link.href = DOSHA_QUIZ_FAVICON_URL;
    });

    if (existingLinks.length === 0) {
      const faviconLink = document.createElement("link");
      faviconLink.rel = "icon";
      faviconLink.type = "image/x-icon";
      faviconLink.href = DOSHA_QUIZ_FAVICON_URL;
      document.head.appendChild(faviconLink);
    }

    if (!restoreOnUnmount) {
      return undefined;
    }

    return () => {
      document.querySelectorAll("link[rel*='icon']").forEach((link, index) => {
        if (originalHrefs[index]) {
          link.href = originalHrefs[index].href;
        } else {
          link.href = defaultFaviconUrl;
        }
      });
    };
  }, [restoreOnUnmount]);
}
